import { MOCK_MODE_EXISTING_CUSTOMER } from './mswFlags';
import { existingCustomerMSWMockHandlers } from '../hooks/mocks/existingCustomerMSWMockHandlers';

export const handlers = [...(MOCK_MODE_EXISTING_CUSTOMER ? existingCustomerMSWMockHandlers : [])];
